export default __webpack_public_path__ + "static/media/copolla-todo.bc938bdd.png";